import { Box, Fade } from '@mui/material'
import { TabPanelProps } from './TabPanel.types'

export const TabPanel = ({
  children,
  value,
  index,
  ...rest
}: TabPanelProps) => {
  const isActive = value === index
  return (
    <div
      role="tabpanel"
      hidden={!isActive}
      id={`tabpanel-${index}`}
      aria-labelledby={`tab-${index}`}
      {...rest}
    >
      {isActive && (
        <Fade in={isActive} timeout={400}>
          <Box p={0} pt={1}>
            {children}
          </Box>
        </Fade>
      )}
    </div>
  )
}
